import {axiosInstance, getAuthToken}  from "../utils/Client";

export default class AgencyPerformanceService {
    static getPerformanceScores = (locationId) => {
        return axiosInstance.get(`/performance_score/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getCombinedPerformanceScores = () => {
        return axiosInstance.get(`/performance_score/combined/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getLocationCount = () => {
        return axiosInstance.get(`/location/count/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getIndividualPerformanceData = (userId) => {
        return axiosInstance.get(`/performance_data/${userId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getDepartmentInfo = (userId) => {
        return axiosInstance.get(`/user_department/${userId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getUserList = () => {
        return axiosInstance.get(`/user/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static compensationList = async (userId) => {
        return await axiosInstance.get(`/compensation/list/${userId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    // get list of staff sales data of the logged-in user
    static getStaffRevenues = (compProfileId) => {
        return axiosInstance.get(`/staff_revenue/list/${compProfileId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    // update staff sales data of the logged-in user
    static updateStaffRevenues = (compProfileId, revenues) => {
        return axiosInstance.put(`/staff_revenue/${compProfileId}/`, revenues,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    // get ltotal agency revenue
    static getAgencyTotalRevenues = (plProfileId) => {
        return axiosInstance.get(`/revenue/actual/total/${plProfileId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/services/AgencyPerformanceService.js